import React, { useState, useEffect } from "react";
import { Dialog, DialogTitle, DialogContent, Button, TextField, Box, Typography, Grid, IconButton, FormControlLabel, FormControl, RadioGroup, Radio } from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useParams } from "react-router-dom";
import moment from "moment/moment";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { RxCross2 } from "react-icons/rx";
import {
    useUpdateStatutoryApprovalMutation,
    //useGetAllStatutoryApprovalCategoryCountQuery, 
    useGetAllStatutoryApprovalDurationCountQuery
} from "store/slices/apis/statutoryApprovalSlice";
import { useGetAllContactsQuery } from "store/slices/apis/contactSlice";
import DocumentManagement from "components/DocumentManagement";
import CustomTabs from "components/CustomTabs";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { mapAndSortAlphabetically } from "utils/mapSortHelper";

const rightLabelStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
};

const rightTextStyle = {
    "& .MuiInputBase-input": {
        fontWeight: 400,
        fontSize: "16px",
        lineHeight: "100%",
        letterSpacing: "0.16px",
        color: "#0A0A0C",
        fontFamily: "Outfit, sans-serif",
    },
};

const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};

const calenderSVG = (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clip-path="url(#clip0_894_610)">
            <path d="M12.6667 1.33333H12V0.666667C12 0.489856 11.9298 0.320286 11.8047 0.195262C11.6797 0.0702379 11.5101 0 11.3333 0C11.1565 0 10.987 0.0702379 10.8619 0.195262C10.7369 0.320286 10.6667 0.489856 10.6667 0.666667V1.33333H5.33333V0.666667C5.33333 0.489856 5.2631 0.320286 5.13807 0.195262C5.01305 0.0702379 4.84348 0 4.66667 0C4.48986 0 4.32029 0.0702379 4.19526 0.195262C4.07024 0.320286 4 0.489856 4 0.666667V1.33333H3.33333C2.4496 1.33439 1.60237 1.68592 0.97748 2.31081C0.352588 2.93571 0.00105857 3.78294 0 4.66667L0 12.6667C0.00105857 13.5504 0.352588 14.3976 0.97748 15.0225C1.60237 15.6474 2.4496 15.9989 3.33333 16H12.6667C13.5504 15.9989 14.3976 15.6474 15.0225 15.0225C15.6474 14.3976 15.9989 13.5504 16 12.6667V4.66667C15.9989 3.78294 15.6474 2.93571 15.0225 2.31081C14.3976 1.68592 13.5504 1.33439 12.6667 1.33333ZM1.33333 4.66667C1.33333 4.13623 1.54405 3.62753 1.91912 3.25245C2.29419 2.87738 2.8029 2.66667 3.33333 2.66667H12.6667C13.1971 2.66667 13.7058 2.87738 14.0809 3.25245C14.456 3.62753 14.6667 4.13623 14.6667 4.66667V5.33333H1.33333V4.66667ZM12.6667 14.6667H3.33333C2.8029 14.6667 2.29419 14.456 1.91912 14.0809C1.54405 13.7058 1.33333 13.1971 1.33333 12.6667V6.66667H14.6667V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667Z" fill="#433F5E" />
            <path d="M8 11C8.55228 11 9 10.5523 9 10C9 9.44772 8.55228 9 8 9C7.44772 9 7 9.44772 7 10C7 10.5523 7.44772 11 8 11Z" fill="#433F5E" />
            <path d="M4.66656 11C5.21885 11 5.66656 10.5523 5.66656 10C5.66656 9.44772 5.21885 9 4.66656 9C4.11428 9 3.66656 9.44772 3.66656 10C3.66656 10.5523 4.11428 11 4.66656 11Z" fill="#433F5E" />
            <path d="M11.3334 11C11.8857 11 12.3334 10.5523 12.3334 10C12.3334 9.44772 11.8857 9 11.3334 9C10.7811 9 10.3334 9.44772 10.3334 10C10.3334 10.5523 10.7811 11 11.3334 11Z" fill="#433F5E" />
        </g>
        <defs>
            <clipPath id="clip0_894_610">
                <rect width="16" height="16" fill="white" />
            </clipPath>
        </defs>
    </svg>
);

const tabs = ["Approval Information", "Documents"]

const EditApproval = (props) => {
    const { open, handleClose, approvalData, refetchCounts } = props;
    const { projectId } = useParams();
    const dispatch = useDispatch();

    const [updateApproval, { isLoading: isUpdating }] = useUpdateStatutoryApprovalMutation();
    //const { refetch: refetchCategoryCount } = useGetAllStatutoryApprovalCategoryCountQuery(projectId);
    const { refetch: refetchDurationCount } = useGetAllStatutoryApprovalDurationCountQuery(projectId);
    const statutoryTrackerId = approvalData.statutoryTrackerId;
    const { data: contactsData, isFetching, error } = useGetAllContactsQuery();
    const [tabValue, setTabValue] = useState(0);
    // console.log("rowData", approvalData);

    const module = "StatutoryApproval";

    const { data: statutoryApprovalStatusRes } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: projectId });
    const statutoryApprovalStatusData = statutoryApprovalStatusRes?.data || [];
    const statusOptions = (statutoryApprovalStatusData || []).map(p => ({
        value: p?.value,
        label: p?.value,
    }));

    const { data: statutoryApprovalPhaseRes } = useGetMasterDataQuery({ module: module, category: 'Phase', ProjectId: projectId });
    const statutoryApprovalPhaseData = statutoryApprovalPhaseRes?.data || [];
    const phaseOptions = mapAndSortAlphabetically(statutoryApprovalPhaseData);

    const { data: statutoryApprovalSPOCRes } = useGetMasterDataQuery({ module: module, category: 'SPOC', ProjectId: projectId });
    const statutoryApprovalSPOCData = statutoryApprovalSPOCRes?.data || [];
    const spocOptions = mapAndSortAlphabetically(statutoryApprovalSPOCData);

    const contactListRes = React.useMemo(() => {
        if (!contactsData?.data) return [];

        return mapAndSortAlphabetically( contactsData.data, "name", "email" );
        
    }, [contactsData]);

    const [initialFormData, setInitialFormData] = useState({
        phase: "",
        approvalAgreement: "",
        permitEntity: "",
        validity: "",
        details: "",
        status: "",
        timeline: "",
        spoc: "",
        targetDate: "",
        responsibility: "",
        remarks: "",
        statutoryTrackerType: "",
        projectId: projectId,
    });


    const formatDateForInput = (dateString) => {
        if (!dateString) return "";
        return moment(dateString).format("YYYY-MM-DD");
    };


    useEffect(() => {
        if (approvalData && open) {
            const formattedData = {
                phase: approvalData.phase || "",
                approvalAgreement: approvalData.permitApprovalAgreement || "",
                permitEntity: approvalData.permittingEntity || "",
                validity: formatDateForInput(approvalData.validity),
                details: approvalData.details || "",
                status: approvalData.status || "",
                timeline: formatDateForInput(approvalData.timelines),
                spoc: approvalData.spoc || "",
                targetDate: formatDateForInput(approvalData.targetDate),
                responsibility: approvalData.responsibility || "",
                remarks: approvalData.remarks || "",
                projectId: projectId,
                statutoryTrackerType: approvalData.statutoryTrackerType || ""
            };
            setInitialFormData(formattedData);
        }
    }, [approvalData, open, projectId]);

    const validationSchema = Yup.object({
        phase: Yup.string().required("Phase field is required"),
        approvalAgreement: Yup.string().required("Permit/Approval/Agreement field is required"),
        permitEntity: Yup.string().required("Permitting Entity field is required"),
        validity: Yup.date().required("Validity field is required"),
        details: Yup.string().required("Details field is required"),
        status: Yup.string().required("Status field is required"),
        timeline: Yup.date().required("Timelines field is required"),
        spoc: Yup.string().required("SPOC field is required"),
        statutoryTrackerType: Yup.string().required("statutoryTrackerType field is required"),
        targetDate: Yup.date().required("Target Timelines field is required"),
        responsibility: Yup.string().required("Responsibility field is required"),
        // remarks: Yup.string().required("Remarks field is required"),
    });

    const handleSubmit = async (values, { setSubmitting }) => {
        let reqBody = {
            statutoryTrackerId: statutoryTrackerId,
            projectCode: "string",
            phase: values?.phase,
            permitApprovalAgreement: values?.approvalAgreement,
            permittingEntity: values?.permitEntity,
            details: values?.details,
            status: values?.status,
            spoc: values?.spoc,
            responsibility: values?.responsibility,
            remarks: values?.remarks,
            isActive: true,
            statutoryTrackerType: values.statutoryTrackerType,
            targetDate: moment.utc(values?.targetDate, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]'),
            validity: moment.utc(values?.validity, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]'),
            timelines: moment.utc(values?.timeline, 'YYYY-MM-DD').format('YYYY-MM-DDTHH:mm:ss[Z]')
        };

        console.log("Update Request Body:", reqBody);

        try {
            const response = await updateApproval({ body: reqBody }).unwrap();
            openNotification("Approval updated successfully", "success");
            setSubmitting(false);
            refetchCounts()
            refetchDurationCount();
            handleClose();

        } catch (error) {
            openNotification(error?.error ?? "Something went wrong", "error");
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: 'alert',
                alert: {
                    color: type
                },
                close: false
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };

    // if (isDataLoading && open) {
    //     return (
    //         <Dialog open={open} fullWidth maxWidth="md">
    //             <DialogTitle>Loading...</DialogTitle>
    //             <DialogContent>
    //                 <Typography>Loading approval data...</Typography>
    //             </DialogContent>
    //         </Dialog>
    //     );
    // }

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden"
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
                borderBottom: "1px solid #ddd",
                backgroundColor: "#ECECEC",
                pb: 2,
                pt: 3,
                width: "100%",
                position: "relative",
            }}>
                <Typography sx={{
                    fontWeight: 600,
                    fontSize: "27px",
                    lineHeight: "100%",
                    color: "#140F36",
                    fontFamily: "Outfit, sans-serif"
                }}>
                    Edit Approval
                </Typography>
                <IconButton
                    aria-label="close"
                    onClick={() => handleClose()}
                    sx={(theme) => ({
                        position: "absolute",
                        right: 50,
                        top: 8,
                        color: theme.palette.grey[500],

                    })}
                >
                    <RxCross2 size={30} color="#140F36" />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    <Grid size={12}>
                        <CustomTabs tabs={tabs} handleTabChange={handleTabChange} tabValue={tabValue} />
                    </Grid>
                    {tabValue === 0 &&
                        <Grid size={12}>
                            <Formik
                                enableReinitialize={true}
                                initialValues={initialFormData}
                                validationSchema={validationSchema}
                                onSubmit={handleSubmit}
                            >
                                {({ values,
                                    errors,
                                    touched,
                                    handleChange,
                                    handleBlur,
                                    handleSubmit,
                                    isSubmitting,
                                    setFieldValue,
                                    setFieldTouched }) => (
                                    <form onSubmit={handleSubmit}>
                                        <Grid container spacing={2}>
                                            <Grid size={12}>
                                                <Typography sx={{ mt: 1, mb: 0, fontSize: "22px", fontWeight: 500, fontFamily: "Outfit, sans-serif", color: "#0A0A0C" }}>
                                                    Approval Details
                                                </Typography>
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <FormControl>
                                                    <Typography sx={labelTextStyle}>Select Category</Typography>
                                                    <RadioGroup
                                                        row
                                                        aria-labelledby="demo-row-radio-buttons-group-label"
                                                        name="statutoryTrackerType"
                                                        value={values.statutoryTrackerType}
                                                        onChange={(e) => {
                                                            setFieldValue("statutoryTrackerType", e.target.value);
                                                        }}
                                                    >
                                                        <FormControlLabel value="PRE AD" control={<Radio />} label="PRE AD" />
                                                        <FormControlLabel value="POST AD-Rail Operation" control={<Radio />} label="POST AD-Rail Operations" />
                                                        <FormControlLabel value="WH" control={<Radio />} label="WH" />
                                                        <FormControlLabel value="ICD" control={<Radio />} label="ICD" />
                                                        <FormControlLabel value="Admin" control={<Radio />} label="Admin" />
                                                    </RadioGroup>
                                                    {touched.statutoryTrackerType && errors.statutoryTrackerType && (
                                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                            {errors.statutoryTrackerType}
                                                        </Typography>
                                                    )}
                                                </FormControl>
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Select Phase
                                                </Typography>
                                                <Select
                                                    name="phase"
                                                    options={phaseOptions}
                                                    value={phaseOptions.find(opt => opt.value === String(values.phase)) || null}
                                                    onChange={(option) => setFieldValue("phase", option.value)}
                                                    onBlur={() => setFieldTouched("phase", true)}
                                                    placeholder="Select Phase"
                                                />
                                                {touched.phase && errors.phase && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.phase}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Permit/Approval/Agreement</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="approvalAgreement"
                                                    value={values.approvalAgreement}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter Permit/Approval/Agreement"

                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.approvalAgreement && errors.approvalAgreement && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.approvalAgreement}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={labelTextStyle}>Permitting Entity</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="permitEntity"
                                                    value={values.permitEntity}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    placeholder="Enter Permitting Entity"

                                                    InputProps={{
                                                        sx: {
                                                            height: "40px",
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& input::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& input": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                                "&:-webkit-autofill": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:hover": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                                "&:-webkit-autofill:focus": {
                                                                    WebkitBoxShadow: "0 0 0 1000px white inset",
                                                                    WebkitTextFillColor: "#0A0A0C",
                                                                },
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.permitEntity && errors.permitEntity && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.permitEntity}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                    Validity Date
                                                </Typography>
                                                <TextField
                                                    type="date"
                                                    name="validity"
                                                    value={values.validity}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onClick={(e) => {
                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                        if (input) input.showPicker?.();
                                                    }}
                                                    fullWidth

                                                    sx={{
                                                        ...rightTextStyle,
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& input[type='date']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                {calenderSVG}
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#fff",
                                                            border: '1px solid',
                                                            borderColor: 'hsl(0, 0%, 80%)',
                                                            height: "40px",
                                                            width: { xs: "100%", md: "100%" },
                                                            borderRadius: "5px",
                                                        },
                                                    }}
                                                />
                                                {touched.validity && errors.validity && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.validity}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography sx={labelTextStyle}>Details</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="details"
                                                    value={values.details}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    multiline
                                                    rows={3}
                                                    placeholder="Enter Details"

                                                    InputProps={{
                                                        sx: {
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& textarea::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& textarea": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                            },
                                                        },
                                                    }}
                                                />
                                                {touched.details && errors.details && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.details}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Select Status
                                                </Typography>
                                                <Select
                                                    name="status"
                                                    options={statusOptions}
                                                    value={statusOptions.find(opt => opt.value === String(values.status)) || null}
                                                    onChange={(option) => setFieldValue("status", option.value)}
                                                    onBlur={() => setFieldTouched("status", true)}
                                                    placeholder="Select Status"

                                                />
                                                {touched.status && errors.status && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.status}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                    Timelines
                                                </Typography>
                                                <TextField
                                                    type="date"
                                                    name="timeline"
                                                    value={values.timeline}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onClick={(e) => {
                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                        if (input) input.showPicker?.();
                                                    }}
                                                    fullWidth

                                                    sx={{
                                                        ...rightTextStyle,
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& input[type='date']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                {calenderSVG}
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#fff",
                                                            border: '1px solid',
                                                            borderColor: 'hsl(0, 0%, 80%)',
                                                            height: "40px",
                                                            width: { xs: "100%", md: "100%" },
                                                            borderRadius: "5px",
                                                        },
                                                    }}
                                                />
                                                {touched.timeline && errors.timeline && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.timeline}
                                                    </Typography>
                                                )}
                                            </Grid>
                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Select SPOC
                                                </Typography>
                                                <Select
                                                    name="spoc"
                                                    options={spocOptions}
                                                    value={spocOptions.find(opt => opt.value === String(values.spoc)) || null}
                                                    onChange={(option) => setFieldValue("spoc", option.value)}
                                                    onBlur={() => setFieldTouched("spoc", true)}
                                                    placeholder="Select SPOC"

                                                />
                                                {touched.spoc && errors.spoc && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.spoc}
                                                    </Typography>
                                                )}
                                            </Grid>

                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mb: 1, mt: 1 }}>
                                                    Target timelines for attaining the permit
                                                </Typography>
                                                <TextField
                                                    type="date"
                                                    name="targetDate"
                                                    value={values.targetDate}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    onClick={(e) => {
                                                        const input = e.currentTarget.parentElement?.querySelector('input[type="date"]');
                                                        if (input) input.showPicker?.();
                                                    }}
                                                    fullWidth

                                                    sx={{
                                                        ...rightTextStyle,
                                                        "& input::-webkit-calendar-picker-indicator": {
                                                            display: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& input[type='date']": {
                                                            appearance: "none",
                                                            WebkitAppearance: "none",
                                                        },
                                                        "& .MuiOutlinedInput-root": {
                                                            "& fieldset": {
                                                                border: "none",
                                                            },
                                                        },
                                                    }}
                                                    InputProps={{
                                                        startAdornment: (
                                                            <Box sx={{ ml: 2, mr: 1, color: "#433F5E", display: "flex", alignItems: "center", cursor: "pointer" }}>
                                                                {calenderSVG}
                                                            </Box>
                                                        ),
                                                        sx: {
                                                            backgroundColor: "#fff",
                                                            border: '1px solid',
                                                            borderColor: 'hsl(0, 0%, 80%)',
                                                            height: "40px",
                                                            width: { xs: "100%", md: "100%" },
                                                            borderRadius: "5px",
                                                        },
                                                    }}
                                                />
                                                {touched.targetDate && errors.targetDate && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.targetDate}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 6 }}>
                                                <Typography sx={{ ...rightLabelStyle, mt: 1, mb: 1 }}>
                                                    Select Responsibility
                                                </Typography>
                                                <Select
                                                    name="responsibility"
                                                    options={contactListRes}
                                                    value={contactListRes.find(opt => opt.value === String(values.responsibility)) || null}
                                                    onChange={(option) => setFieldValue("responsibility", option.value)}
                                                    onBlur={() => setFieldTouched("responsibility", true)}
                                                    placeholder="Select Responsibility"

                                                />
                                                {touched.responsibility && errors.responsibility && (
                                                    <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                        {errors.responsibility}
                                                    </Typography>
                                                )}
                                            </Grid>


                                            <Grid size={{ xs: 12, md: 12 }}>
                                                <Typography sx={labelTextStyle}>Remarks</Typography>
                                                <TextField
                                                    fullWidth
                                                    name="remarks"
                                                    value={values.remarks}
                                                    onChange={handleChange}
                                                    onBlur={handleBlur}
                                                    multiline
                                                    rows={3}
                                                    placeholder="Enter Remarks"

                                                    InputProps={{
                                                        sx: {
                                                            borderRadius: "8px",
                                                            backgroundColor: "#fff",
                                                            "& textarea::placeholder": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#5F5F5F",
                                                                fontFamily: "Outfit, sans-serif",
                                                                opacity: 1,
                                                            },
                                                            "& textarea": {
                                                                fontWeight: 400,
                                                                fontSize: "16px",
                                                                lineHeight: "100%",
                                                                letterSpacing: "0.16px",
                                                                color: "#0A0A0C",
                                                                fontFamily: "Outfit, sans-serif",
                                                            },
                                                        },
                                                    }}
                                                />
                                                {/* {touched.remarks && errors.remarks && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.remarks}
                                        </Typography>
                                    )} */}
                                            </Grid>

                                            <Grid size={12}>
                                                <Box
                                                    sx={{
                                                        display: "flex",
                                                        justifyContent: "flex-end",
                                                        alignItems: "center",
                                                        gap: 2,
                                                    }}
                                                >
                                                    <Button onClick={handleClose}
                                                        sx={{
                                                            textTransform: "none",
                                                            color: "#F15744",
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                            borderRadius: "25px",
                                                            fontWeight: 500,
                                                            px: "20px",
                                                            py: "15px",
                                                        }}>
                                                        Cancel
                                                    </Button>
                                                    <Button
                                                        type="submit"
                                                        variant="contained"
                                                        disabled={isSubmitting}
                                                        sx={{
                                                            backgroundColor: "#00344C",
                                                            borderRadius: "25px",
                                                            textTransform: "none",
                                                            fontWeight: 500,
                                                            fontSize: "14px",
                                                            lineHeight: "100%",
                                                            fontFamily: "Outfit, sans-serif",
                                                            color: "#FFFFFF",
                                                            px: "20px",
                                                            py: "15px",
                                                            '&:disabled': {
                                                                backgroundColor: '#cccccc',
                                                            }
                                                        }}
                                                    >
                                                        {isSubmitting ? "Updating..." : "Update"}
                                                    </Button>
                                                </Box>
                                            </Grid>
                                        </Grid>
                                    </form>
                                )}
                            </Formik>
                        </Grid>
                    }
                    {tabValue === 1 &&
                        <Grid size={{ md: 12, xs: 12 }}>
                            <DocumentManagement id={approvalData?.statutoryTrackerId} entityType="Statutory" customId={approvalData?.customId} />
                        </Grid>
                    }
                </Grid>
            </DialogContent>
        </Dialog>
    );
};

export default EditApproval;